import * as React from 'react'
import { toast } from 'sonner'

import { api } from '@/lib/api'
import { useAuthStore } from '@/store/auth'

/**
 * 全域 Email 未驗證提示條。
 * 已登入但 user.email_verified === false 才顯示；提供重寄按鈕。
 * dashboard / 各 AuthLayout 頁面頂端使用。
 */
export function EmailVerifyBanner() {
  const user = useAuthStore((s) => s.user)
  const [sending, setSending] = React.useState(false)
  const [dismissed, setDismissed] = React.useState(false)

  if (!user || user.email_verified !== false || dismissed) return null

  async function handleResend() {
    setSending(true)
    try {
      const res = await api.post('api/auth/email/resend').json<{ sent: boolean; message: string }>()
      toast[res.sent ? 'success' : 'info'](res.message)
    } catch (e: unknown) {
      const status = (e as { response?: { status?: number } })?.response?.status
      toast.error(status === 429 ? '請稍候 60 秒後再重寄' : '重寄失敗，請稍後重試')
    } finally {
      setSending(false)
    }
  }

  return (
    <div
      className="px-4 py-2.5 flex items-center justify-center gap-3 flex-wrap text-sm"
      style={{
        background: 'var(--color-sun)',
        borderBottom: '2px solid var(--color-border)',
        color: 'var(--color-foreground)',
      }}
    >
      <span>
        ✉ <strong>{user.email}</strong> 尚未驗證 — 驗證後可領 500 點、兌換獎勵、使用 AI 配額
      </span>
      <button
        type="button"
        onClick={handleResend}
        disabled={sending}
        className="font-pixel disabled:opacity-60"
        style={{
          border: '2px solid var(--color-border)',
          background: 'var(--color-coral)',
          color: 'white',
          fontSize: 9,
          padding: '4px 10px',
          cursor: 'pointer',
          boxShadow: '2px 2px 0 0 var(--color-border)',
          letterSpacing: '0.06em',
        }}
      >
        {sending ? '寄送中...' : '重寄驗證信'}
      </button>
      <button
        type="button"
        onClick={() => setDismissed(true)}
        aria-label="關閉提示"
        className="text-xs"
        style={{
          border: '2px solid var(--color-border)',
          background: 'var(--color-surface)',
          color: 'var(--color-foreground)',
          width: 22, height: 22,
          cursor: 'pointer',
          fontWeight: 700,
        }}
      >✕</button>
    </div>
  )
}

export default EmailVerifyBanner
